var map = {
	"./2017-2021.pdf": 87873,
	"./2018-2022.pdf": 98095,
	"./2019-2023.pdf": 44509,
	"./2020-2024.pdf": 82270,
	"./2021-2025.pdf": 33271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70393;